import { createContext } from 'react'

/**
 * Guarded "leave the form-type editor" action, provided by FormTypeConfigurator
 * (its breadcrumb "back" handler): shows the UnsavedChangesDialog when there are
 * unsaved changes, then exits to the workflow-types list. Nested surfaces (e.g.
 * the linked-workflow "Allow to select" selector's "Workflow Configurator" link)
 * consume it so they route through the same discard confirmation instead of
 * resetting the editor and silently dropping in-progress edits. Null outside a
 * FormTypeConfigurator.
 */
export const FormTypeConfiguratorExitContext = createContext<
  (() => void) | null
>(null)
